import type { IconProps } from '../types/IconProps.ts';
export const Pin: IconProps = {
    name: 'Pin',
    children: [
        `<path d="M6 4c0-1.1.9-2 2-2h8a2 2 0 1 1 0 4 1 1 0 0 0-1 1v2.33a2 2 0 0 0 .4 1.2l2.2 2.94a2 2 0 0 1 .4 1.2V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1.17a2 2 0 0 1 .59-1.42L8.4 11.6a2 2 0 0 0 .6-1.43V7a1 1 0 0 0-1-1 2 2 0 0 1-2-2M12 17v5" />`,
    ]
};